/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-26 15:07:36
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-10-09 14:16:12
 * @FilePath: \pit-bimwin-react-ui\src\core\createBimWin.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BWOptions, ISecret, Platform } from 'bimwin-api';
// import { Platform as PlatformType } from 'bimwin-api/types/api'
import { error } from '../utils/error';
interface PlatformType {
  platform: any;
  type: any;
}
/**
 * 初始化bimwin实例
 * @param el
 * @param fileId
 * @param options
 * @param headers
 * @return {Platform}
 */
export interface optionsType extends BWOptions {
  fileId: string;
}
export function createBimWin(
  el: HTMLDivElement,
  options: optionsType,
  headers: ISecret
): Promise<PlatformType> {
  if (!options.fileId) {
    error('fileId 不能为空');
  }
  options = {
    secret: headers,
    ...options,
  };
  if (!options.el) options.el = el;

  return new Promise(resolve => {
    let platform = new Platform(options);
    platform.Service.GetFileBimType(options.fileId).then((type: any) => {
      options.type = type;
      platform.Init();
      platform.Model.LoadModel(
        [options.fileId],
        {
          viewDirection: 0b100101,
          fitView: true,
          sceneMatrix: undefined,
        },
        () => {
          resolve({
            platform: platform,
            type: type,
          });
        }
      );
    });
  });
}

/**
 * 设置场景背景色
 * @param {Platform} platform
 * @param color
 */
export function setBackgroundColor(platform: Platform, color: any) {
  platform.bimwin.canvas.style.background = color;
}
/**
 * 显示/隐藏线框
 * @param {Platform} platform
 * @param {Boolean} flag
 */
export function setLineIsHide(platform: any, flag: boolean) {
  platform.bimwin.setLineIsHide(flag);
}

/**
 * 更改为天空盒背景
 * @param {Platform} platform
 */
export function setDefaultSkyBox(platform: any) {
  platform.bimwin.setDefaultSkyBox([
    require('../assets/images/skybox/front.jpg'),
    require('../assets/images/skybox/back.jpg'),
    require('../assets/images/skybox/top.jpg'),
    require('../assets/images/skybox/bottom.jpg'),
    require('../assets/images/skybox/left.jpg'),
    require('../assets/images/skybox/right.jpg'),
  ]);
}

/**
 * 点选模式
 * @param {Platform} platform
 * @param {SelectMode} mode
 */
export function setSelectMode(platform: any, mode: string) {
  platform.bimwin.setSelectMode(mode);
}

/**
 * 鼠标悬停
 * @param {Platform} platform
 * @param {Boolean} flag
 */
export function outlineNodeSetEnable(platform: any, flag: boolean) {
  platform.bimwin.outlineNode?.SetEnable(flag);
}

/**
 * 设置曝光度
 * @param {Platform} platform
 * @param {Number} number
 */
export function setLightIntensity(platform: any, number: number) {
  platform.Light.SetLightIntensity(number);
}

/**
 * 微调按键速度
 * @param {Platform} platform
 * @param {Number} number
 */
export function setSpeed(platform: any, number: number) {
  platform.bimwin.setSpeed(number);
}

/**
 * 平行投影光
 * @param {Platform} platform
 * @param {Boolean} flag
 */
export function StartUsingShadow(platform: any, flag: boolean) {
  platform.bimwin.StartUsingShadow(flag);
}
